export default __webpack_public_path__ + "static/B0137-a6426fc172bd921a3df590eec511d467.png";